import Web3Modal from "web3modal";
import WalletConnect from "@walletconnect/web3-provider";

// import { getChainData } from "./helpers";
// {
//   infuraId: "e23b9a3aa4b34f89ba081b54790f6010",
//   qrcodeModalOptions: {
//     mobileLinks: ["metamask", "argent", "trust", "imtoken", "pillar"],
//   },
//   rpc: {
//     1: "https://mainnet.mycustomnode.com",
//     4: "https://rinkeby.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
//     56: "https://bsc-dataseed1.binance.org",
//     97: "https://data-seed-prebsc-1-s1.binance.org:8545",
//     137: "https://polygon-rpc.com",
//     80001: "https://matic-mumbai.chainstacklabs.com",
//   },
// }

const providerOptions = {
  walletconnect: {
    package: WalletConnect,
    options: {
      infuraId: process.env.REACT_APP_INFURA_ID,
      qrcodeModalOptions: {
        mobileLinks: ["metamask", "argent", "trust", "imtoken", "pillar"],
        desktopLinks: [],
      },
      rpc: {
        1: "https://mainnet.mycustomnode.com",
        4: "https://rinkeby.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
        137: "https://polygon-rpc.com",
        80001: "https://matic-mumbai.chainstacklabs.com",
        56: "https://bsc-dataseed1.binance.org",
        97: "https://data-seed-prebsc-1-s1.binance.org:8545",
        512: "https://rpc.acuteangle.com",
        513: "https://rpc-testnet.acuteangle.com",
      },
    },
  },
  // torus: {
  //   package: Torus,
  // },
  // coinbasewallet: {
  //   package: CoinbaseWalletSDK,
  //   options: {
  //     appName: "Web3Modal Example App",
  //     infuraId,
  //   },
  // },
};

// export const getNetwork = (chainId) => getChainData(chainId).network;

// export const CreateWeb3Modal = (chainId) => {
//   // eslint-disable-next-line no-unused-vars
//   const network = getNetwork(chainId);
//   //TODO
//   const web3Modal = new Web3Modal({
//     // network: "matic",
//     // network: getNetwork(chainId) ,
//     cacheProvider: true,
//     providerOptions: getProviderOptions(),
//   });

//   return web3Modal;
// };

export const web3Modal = new Web3Modal({
  cacheProvider: true,
  providerOptions: providerOptions,
  disableInjectedProvider: false,
});
